export const ROUTES = {
  HOME: '/',
  LIVE_MEETING: '/live',
  MEETING_STATS: '/meetingstats',
  PREVIEW_MEETING: '/preview',
  PREVIEW_CASE: '/previewCase',

  ADMIN: '/admin',
  ADMIN_CASE_LIST: '/admin/allcases',
  ADMIN_CASE_EDIT: '/admin/case',
  // ADMIN_CASE_VIEW: '/admin/view/case',
  ADMIN_TEST: '/admin/test',

  ADMIN_USER_LIST: '/admin/allusers',

  ADMIN_CLIENTS: '/admin/clients',
  ADMIN_TEAMS: '/admin/teams',
  ADMIN_MEETING_LIST: '/admin/allmeetings',
  ADMIN_CASE_CLUSTER_LIST: '/admin/caseClusters',
  ADMIN_CLICKUP: '/admin/clickup',
  ADMIN_SALES: '/admin/sales',
  LIVEKIT_TEST: '/test/livekit',
};
